module.exports = __webpack_public_path__ + "img/5-colorful.1482da9c.png";